import { Injectable } from '@angular/core';
import { DEFAULT_WORKFLOW_ORIENTATION, WorkflowOrientation } from '../store/workflow-layout';

/**
 * Remembers which way the canvas lays workflows out. A viewing preference
 * rather than workflow data — it belongs to the person, not the workflow, so
 * it rides in localStorage alongside the other per-browser designer settings.
 */
@Injectable({
  providedIn: 'root'
})
export class WorkflowOrientationService {
  private readonly STORAGE_KEY = 'workflow-designer-orientation';

  read(): WorkflowOrientation {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored === 'horizontal' || stored === 'vertical'
        ? stored
        : DEFAULT_WORKFLOW_ORIENTATION;
    } catch {
      // Storage blocked (private mode, a locked-down profile): lay out the
      // default rather than fail to open the designer at all.
      return DEFAULT_WORKFLOW_ORIENTATION;
    }
  }

  write(orientation: WorkflowOrientation): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, orientation);
    } catch (error) {
      console.error('Error saving workflow orientation preference:', error);
    }
  }
}
